import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-video-stream-dialog',
  templateUrl: './video-stream-dialog.component.html',
  styleUrls: ['./video-stream-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class VideoStreamDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<VideoStreamDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}
}
